import React, { Component } from "react";
import { Form, Input, Button, Row, Col, Typography, Card } from 'antd';
import logo from '../images/swan-logo-blue.svg';
import { AiOutlineUser } from 'react-icons/ai';
import { RiLockPasswordLine } from 'react-icons/ri';


const { Text } = Typography;

class LoginForm extends Component {
    render() {
        return (
            <div className='loginForm'>
                <Row style={{ minHeight: "85vh", width: '100%' }}>
                    {/* <Col xs={0} sm={0} md={4} lg={5}>
                        <div className='sideBg'></div>
                    </Col> */}
                    <Col xs={24} sm={24} md={24} lg={24} style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center', }} >
                        <div style={{ textAlign: 'center', color: 'rgb(0, 47, 135)' }}>
                            {/* <img alt="Swan Logo" src={logo} width={250} /> */}
                            <h1 style={{ color: 'rgb(0, 47, 135)', margin: 0, fontSize: '40px' }} className="globerFont">Welcome</h1>
                            <h1 style={{ color: 'rgb(0, 47, 135)', fontSize: '25px' }} className="globerFont">to our Breakdown Service Portal</h1>
                        </div>
                        <Card
                            title={<Row justify="center">Please enter your credentials to proceed</Row>}
                            style={{ borderRadius: 10 }}
                            hoverable
                        >
                            <Form
                                name="admin_login"
                                layout="vertical"
                                initialValues={{
                                    username: "",
                                    password: "",
                                }}
                                onFinish={this.props.validateLogin}
                                autoComplete="off"
                            >
                                <Form.Item
                                    label="Username"
                                    name="username"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your username!',
                                        },
                                    ]}
                                >
                                    <Input
                                        prefix={<AiOutlineUser />}
                                        style={{ borderRadius: 10 }}
                                        maxLength='20'
                                        placeholder="Username"
                                        autoFocus
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Password"
                                    name="password"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your password!',
                                        },
                                    ]}
                                >
                                    <Input.Password
                                        prefix={<RiLockPasswordLine />}
                                        style={{ borderRadius: 10 }}
                                        type="password"
                                        maxLength='40'
                                        placeholder="Password"
                                    />
                                </Form.Item>
                                <br />
                                <Form.Item>
                                    <Button
                                        htmlType="submit"
                                        shape="round"
                                        loading={this.props.loadingLoginBtn}
                                        style={{
                                            backgroundColor: "#002F87",
                                            height: "25%",
                                            width: "100%",
                                        }}
                                    >
                                        <Text
                                            style={{
                                                color: "#ffffff",
                                                fontSize: 20,
                                            }}
                                        >
                                            Log in
                                        </Text>
                                    </Button>
                                </Form.Item>
                                <br />
                                {/* <Row justify="center">
                                        <Col span={24}>
                                        </Col>
                                    </Row> */}
                                <Row justify="end">
                                    {/* <Form.Item> */}
                                        {/* <Button type="link" style={{ color: "#002F87" }}>
                                            Forgot password?
                                        </Button> */}
                                    {/* </Form.Item>     */}
                                </Row>
                            </Form>
                        </Card>

                    </Col>
                </Row>
                <Row style={{ minHeight: '1vh', width: '100%', display: 'flex', alignItem: 'center', justifyContent: 'center', marginTop: '20px' }}>
                    <img src={logo} alt='SWAN' height={35} style={{ margin: '25px' }} />
                </Row>
            </div>
        )
    }
}

export default LoginForm